export const estadosBloqueados = (valorConfig) =>
    String(valorConfig || '')
        .split(',')
        .map((estado) => estado.trim())
        .filter((estado) => estado !== '');

export const gerenciadorTallerBloqueado = (estado, valorConfig) =>
    !!estado && estadosBloqueados(valorConfig).indexOf(estado) !== -1;
